var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccueilvisiteurs(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-3,.cls-4{stroke:#e6007e;stroke-miterlimit:10;}.cls-1,.cls-3{stroke-linecap:round;stroke-width:2px;}.cls-2,.cls-4{fill:#e6007e;}.cls-3{fill:none;}.cls-4{stroke-width:0.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "syndicat"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.84,22c0,5.74-3.8,10.76-8.2,10.76s-7.75-5-7.75-10.76c0-1.61-.45-6.47.12-7.9.87-2.2,4.69-3.3,7.86-3.3,3,0,7.12.81,8.18,3.29C42.73,15.66,41.84,20.15,41.84,22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M25.87,19.31s2.62-2.52,8.08-2.52S42,19.59,42,19.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31,27.61a3.65,3.65,0,0,0,1.87,1.48,3.57,3.57,0,0,0,3.57-.77,3.38,3.38,0,0,0,.6-.71A.63.63,0,0,0,36,27a.21.21,0,0,1,0,.06l0,0a1.86,1.86,0,0,1-.41.43l-.07.06c.06,0,.06,0,0,0a1.77,1.77,0,0,1-.17.12l-.2.12s-.22.1-.12.06A2.34,2.34,0,0,1,34,28a2.29,2.29,0,0,1-.9-.18L33,27.79l-.19-.12a1.88,1.88,0,0,1-.18-.12c-.06,0,0,0,0,0l-.08-.06a5.51,5.51,0,0,1-.41-.43c-.08-.08.09.14,0,0l0-.06,0-.06a.63.63,0,0,0-1.08.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M16.35,51H51.57s.8-11.29-1.72-13.8-9.22-3.74-9.22-3.74-1.61,1.92-6.4,1.92-6.93-1.92-6.93-1.92-5.56.58-9,4S16.35,51,16.35,51Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 28.51,
    y1: 30.04,
    x2: 27.3,
    y2: 33.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 38.96,
    y1: 30.04,
    x2: 40.63,
    y2: 33.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M37.67,35l-4.22,2.92c-2.41,1.66-4.94,2.35-4.94,5.53V51"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 33.87,
    cy: 43.02,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 33.87,
    cy: 48.04,
    r: 0.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccueilvisiteurs);
export default __webpack_public_path__ + "static/media/accueilvisiteurs.c8c7d5c322a393aa93f6f7bcdfc254f7.svg";
export { ForwardRef as ReactComponent };